import { useTranslation } from 'react-i18next';
import { cn } from '@/core/lib/utils';

interface PasswordStrengthBarProps {
  password: string;
}

function getStrength(password: string): number {
  if (password.length === 0) return 0;
  let s = 0;
  if (password.length >= 8) s++;
  if (/[A-Z]/.test(password)) s++;
  if (/[0-9]/.test(password)) s++;
  if (/[^A-Za-z0-9]/.test(password)) s++;
  return s;
}

const STRENGTH_COLORS = ['', 'bg-destructive', 'bg-warning', 'bg-warning', 'bg-success'];

export function PasswordStrengthBar({ password }: PasswordStrengthBarProps) {
  const { t } = useTranslation('auth');

  const strength = getStrength(password);

  const strengthLabels = [
    '',
    t('strength.weak'),
    t('strength.fair'),
    t('strength.good'),
    t('strength.strong'),
  ];

  if (password.length === 0) return null;

  return (
    <div
      className="flex items-center gap-2 px-1"
      role="status"
      aria-live="polite"
      aria-label={strengthLabels[strength]}
    >
      <div className="flex gap-1 flex-1">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className={cn(
              'h-1 flex-1 rounded-full transition-all duration-300',
              i <= strength ? STRENGTH_COLORS[strength] : 'bg-muted',
            )}
          />
        ))}
      </div>
      <span className="text-xs text-muted-foreground w-14 text-right">
        {strengthLabels[strength]}
      </span>
    </div>
  );
}
